import { AlertCircle, Crown, X } from 'lucide-react';
import Button from '../common/Button';

export default function AlertDialogSlide({ children, title, description, open, setOpen, onConfirm, type = 'warning', confirmTitle }) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <>
      {children}
      <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-all duration-300 ${
        open 
          ? 'bg-black/50 backdrop-blur-sm opacity-100' 
          : 'bg-black/0 backdrop-blur-0 opacity-0 pointer-events-none'
      }`}>
        <div className={`bg-white rounded-2xl shadow-xl border border-gray-200 w-full max-w-md transform transition-all duration-300 ${
          open 
            ? 'scale-100 opacity-100 translate-y-0' 
            : 'scale-95 opacity-0 translate-y-4'
        }`}>
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-100">
            <div className="flex items-center space-x-3">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                type === 'warning' 
                  ? 'bg-amber-100 text-amber-600' 
                  : 'bg-primary-100 text-primary-600'
              }`}>
                {type === 'warning' ? (
                  <AlertCircle className="w-5 h-5" />
                ) : (
                  <Crown className="w-5 h-5" />
                )}
              </div>
              <h3 className="text-xl font-bold text-secondary-900">{title}</h3>
            </div>
            <button
              onClick={handleClose}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-secondary-400 hover:text-secondary-600 hover:bg-gray-100 transition-colors duration-200"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-secondary-600 leading-relaxed">{description}</p>
          </div>

          {/* Actions */}
          <div className="flex gap-3 p-6 border-t border-gray-100">
            <Button
              variant="outline"
              onClick={handleClose}
              className="flex-1 border-gray-300 text-secondary-700 hover:bg-gray-50 transition-colors duration-200"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirm}
              className="flex-1 bg-primary-600 hover:bg-primary-700 text-white transition-colors duration-200"
            >
              {confirmTitle || "Confirm Change"}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}